import { all, fork } from 'redux-saga/effects';
import { authSagas, registerSagas } from './auth';
import { scenariosSagas } from './financial-model/scenarios.sagas';

const combinedSagas = {
  ...authSagas,
  ...registerSagas,
  ...scenariosSagas
};

export default function* rootSaga() {
  yield all(Object.values(combinedSagas).map((saga) => fork(saga)));
}
